import axiosInstance from "../../services/AxiosInstance"

// Action Types
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST"
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE"
export const CLEAR_CHANGE_PASSWORD_STATE = "CLEAR_CHANGE_PASSWORD_STATE"

// Change Password Action
export const changePasswordAction = (passwordData) => {
  return async (dispatch) => {
    dispatch({ type: CHANGE_PASSWORD_REQUEST })

    try {
      console.log("Changing password with data:", passwordData) // Debug log

      const response = await axiosInstance.post("/admin/changePassword", {
        current_password: passwordData.currentPassword,
        new_password: passwordData.newPassword,
        confirm_new_password: passwordData.confirmNewPassword,
      })

      console.log("Change Password Response:", response.data) // Debug log

      dispatch({
        type: CHANGE_PASSWORD_SUCCESS,
        payload: response.data.message || "Password changed successfully",
      })

      return response.data
    } catch (error) {
      console.error("Change Password Error:", error) // Debug log

      dispatch({
        type: CHANGE_PASSWORD_FAILURE,
        payload: error.response?.data?.message || error.message || "Failed to change password",
      })

      throw error
    }
  }
}

// Clear Change Password State
export const clearChangePasswordState = () => ({
  type: CLEAR_CHANGE_PASSWORD_STATE,
})
